export const questionGroups = {
  stabilityOfOrganisationManagement: 'organisation_stability',
  financialViability: 'financial_viability',
  performanceAndSatisfaction: 'performance_satisfaction_group',
  qualityOfCertificationProcess: 'quality_certification_process',
  complianceQualityAssurance: 'compliance_quality_assurance',
  nationalCompetenceBaseline: 'national_competence_baseline',
  cbsCapabilityToOperateCertificationInAdditionalLanguages: 'cb_capability_additional_languages',
  certificationSystemPanelParticipation: 'certification_system_panel_participation',
};

export const questions = {
  cbCurrentOrg: 'cb_current_org',
  cbChanges: 'cb_changes',
  cbOrganisationStability: 'cb_organisation_stability',
  cbFinancialViability: 'cb_financial_viability',
  complaintsAppeals: 'complaints_appeals',
  candidateFeedback: 'candidate_feedback',
  statusGc: 'status_gc',
  performanceSatisfaction: 'performance_satisfaction',
  satisfactionLevelGc: 'satisfaction_level_gc',
  schemePathAssessmentChanges: 'scheme_path_assessment_changes',
  assessors: 'assessors',
  developmentPlan: 'development_plan',
  workshopDates: 'workshop_dates',
  workshopAgenda: 'workshop_agenda',
  managementReveiews: 'management_reveiews',
  internalAudits: 'internal_audits',
  competenceBaseline4lc: 'competence_baseline_4lc',
  cbCertCapabilityAL: 'cb_cert_capability_al',
  cspp: 'cspp',
};
